"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};
var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
import { Component, Ref, Vue } from "vue-property-decorator";
import UiDialog, { UiDialogController } from "@/components/dialog/UiDialog.vue";
import _ from "lodash";
import UiGrid, { GridController } from "@/components/grid/UiGrid.vue";
import { APIDataSource } from "@/components/grid/data-source";
import { Debounce } from "vue-debounce-decorator";
import GridSelector from "@/components/dialog/GridSelector.vue";
let AddInprogressUsersDialog = class extends Vue {
  constructor() {
    super(...arguments);
    this.dialog = new UiDialogController();
    this.gridController = new GridController(
      new APIDataSource("api://base.auth/api/v7/users")
    );
    this.userselectLock = false;
    this.selectedDatas = [];
    this.searchUser = "";
    this.loading = false;
    this.selectedLimit = 0;
    this.limitAll = 0;
    this.usedLimit = 0;
    this.showSelectedLimit = false;
  }
  mounted() {
    return __async(this, null, function* () {
      try {
        this.gridController.pagePosition = "dialog";
        this.gridController.size = true;
        this.gridController.on("searched", (item) => {
          this.byUsercheckItem();
        });
      } catch (error) {
        console.log(error);
      }
    });
  }
  searchByName(searchStr) {
    return __async(this, null, function* () {
      if (searchStr !== null && searchStr !== "") {
        this.gridController.query.params = { search: `name=='%${searchStr}%',account=='%${searchStr}%';` };
        this.gridController.query.current = 1;
      }
      if (searchStr === null || searchStr === "") {
        this.gridController.query.params = { search: `` };
      }
      yield this.gridController.search();
    });
  }
  open(datas, selectedLimit) {
    return __async(this, null, function* () {
      try {
        this.loading = true;
        this.searchUser = "";
        this.selectedDatas = [];
        if (this._byUserGridSelector) {
          this._byUserGridSelector.clear();
        }
        this.dialog.visible = true;
        this.gridController.query.params = null;
        yield this.gridController.search();
        if (selectedLimit) {
          this.limitAll = selectedLimit.quota;
          this.usedLimit = selectedLimit.usedQuota;
          this.showSelectedLimit = true;
          this.selectedLimit = this.limitAll - this.usedLimit;
        } else {
          this.showSelectedLimit = false;
        }
        if (datas) {
          this.userselectLock = true;
          setTimeout(() => {
            this.editSelectedItems(datas);
          }, 10);
        } else {
          this.selectedDatas = [];
        }
        this.userselectLock = false;
        this.$nextTick(() => {
          this._byUserGridSelector.setOptSpan(16, 8);
          if (datas) {
            for (let data of datas) {
              let item = _.find(this.gridController.result.datas, {
                id: data.id
              });
              if (item !== void 0) {
                this._multipleTable.toggleRowSelection(item, true);
              }
            }
          }
        });
      } catch (error) {
        console.log(error);
      } finally {
        this.loading = false;
      }
    });
  }
  clearSearchParams() {
    return __async(this, null, function* () {
      try {
        this.searchUser = "";
        this.gridController.query.params = null;
        yield this.gridController.search();
      } catch (error) {
        if (error.hasOwnProperty("response")) {
          this.$message.error(error.response.data.errors.datas[0].message);
        }
      }
    });
  }
  byUserChanged(data) {
    let rows = _.differenceWith(
      this.selectedDatas,
      data,
      (selectData, data2) => selectData.id == data2.id
    );
    this.userselectLock = true;
    if (rows) {
      for (const row of rows) {
        const selectedItem = _.find(this.gridController.result.datas, {
          id: row.id
        });
        if (selectedItem) {
          this._multipleTable.toggleRowSelection(selectedItem, false);
          this.selectedDatas = this.selectedDatas.filter(
            (data2) => data2.id !== row.id
          );
        }
      }
    }
    this.userselectLock = false;
  }
  byUsercheckItem() {
    var _a;
    let selectDatas = (_a = this._byUserGridSelector) == null ? void 0 : _a.getAll();
    let rows = _.intersectionWith(
      this.gridController.result.datas,
      selectDatas,
      (data, selectData) => selectData.id == data.id
    );
    this.userselectLock = true;
    if (rows) {
      for (const row of rows) {
        this._multipleTable.toggleRowSelection(row, true);
      }
    }
    this.userselectLock = false;
  }
  confirmButton(datas) {
    try {
      let data = {
        selectedUsers: this.selectedDatas
      };
      this.$emit("changeEnvUsers", data);
      this.close();
    } catch (error) {
    }
  }
  editSelectedItems(items) {
    try {
      for (const item of items) {
        const _item = {
          id: item["id"],
          label: `${item["name"]}`
        };
        let _dataitem = _.find(this.selectedDatas, { id: item.id });
        if (_dataitem === void 0) {
          let selectItem = {
            id: item.id,
            label: item.name
          };
          this.selectedDatas.push(selectItem);
        }
        this._byUserGridSelector.add(_item);
      }
    } catch (error) {
      console.log(error);
    }
  }
  selectable(row, index) {
    if (this.showSelectedLimit) {
      if (this.selectedLimit === 0) {
        return false;
      }
      let _data = this._byUserGridSelector.getAllNew();
      if (_data.length >= this.selectedLimit) {
        for (const item of _data) {
          if (item.id === row.id) {
            return true;
          }
        }
        return false;
      }
      if (_data.length === 0 || _data.length < this.selectedLimit) {
        return true;
      }
      return false;
    } else {
      return true;
    }
  }
  selectItems(items) {
    try {
      if (!this.userselectLock) {
        let unSelectData = _.differenceWith(
          this.gridController.result.datas,
          items,
          _.isEqual
        );
        for (const item of items) {
          const _item = {
            id: item["id"],
            label: `${item["name"]}`
          };
          let _dataitem = _.find(this.selectedDatas, { id: item.id });
          if (_dataitem === void 0) {
            if (this.showSelectedLimit) {
              if (this.selectedDatas.length >= this.selectedLimit) {
                this.$message.error(this.$t("add_inprogress_shops.dialog.selected_limit_error"));
                return;
              }
            }
            let selectItem = {
              id: item.id,
              label: item.name
            };
            this.selectedDatas.push(selectItem);
          }
          this._byUserGridSelector.add(_item);
        }
        for (const item of unSelectData) {
          const _item = {
            id: item["id"],
            label: `${item["name"]}`
          };
          this.selectedDatas = this.selectedDatas.filter(
            (data) => data.id !== item.id
          );
          this._byUserGridSelector.del(_item);
        }
      }
    } catch (error) {
      console.log(error);
    }
  }
  close() {
    this.dialog.visible = false;
  }
};
__decorateClass([
  Ref("byUserGridSelector")
], AddInprogressUsersDialog.prototype, "_byUserGridSelector", 2);
__decorateClass([
  Ref("multipleTable")
], AddInprogressUsersDialog.prototype, "_multipleTable", 2);
__decorateClass([
  Debounce(500)
], AddInprogressUsersDialog.prototype, "searchByName", 1);
AddInprogressUsersDialog = __decorateClass([
  Component({
    components: {
      UiDialog,
      UiGrid,
      GridSelector
    }
  })
], AddInprogressUsersDialog);
export {
  AddInprogressUsersDialog as default
};
